import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { Documento } from "../../../types/processo/Documento";

const endpointUrl = configUrls.DOCUMENTO_EDITAR_EP;

function updateDocumento(obj: Documento) {
  
  return {
    url: `${endpointUrl}/${obj.id}`,
    method: "PUT",
    body: obj,
  };
}
export const documentoEditarConteudoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    updateDocumentoEditarConteudo: mutation<Documento, Documento>({
      query: updateDocumento,
      invalidatesTags: ["Documento"],
    }),
  }),
});
export const { useUpdateDocumentoEditarConteudoMutation } = documentoEditarConteudoApiSlice;
